import { render, staticRenderFns } from "./weixinMenuDict.vue?vue&type=template&id=44b4e36a&"
import script from "./weixinMenuDict.vue?vue&type=script&lang=js&"
export * from "./weixinMenuDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports